/* 🤖 this file was generated by svg-to-ts */
export const matIconWidgets: {
  name: 'widgets';
  data: string;
} = {
  name: 'widgets',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m16.66 4.52 2.83 2.83-2.83 2.83-2.83-2.83 2.83-2.83M9 5v4H5V5h4m10 10v4h-4v-4h4M9 15v4H5v-4h4m7.66-13.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65zM11 3H3v8h8V3zm10 10h-8v8h8v-8zm-10 0H3v8h8v-8z"/></svg>`
};
